import { render, staticRenderFns } from "./HasilSurvey.vue?vue&type=template&id=f4175cf0&scoped=true&"
import script from "./HasilSurvey.vue?vue&type=script&lang=js&"
export * from "./HasilSurvey.vue?vue&type=script&lang=js&"
import style1 from "./HasilSurvey.vue?vue&type=style&index=1&id=f4175cf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4175cf0",
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QTable from 'quasar/src/components/table/QTable.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QCard,QCardSection,QDialog,QBtn,QInput,QMarkupTable,QPagination,QTable});qInstall(component, 'directives', {ClosePopup});
